import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import SectionTitle from '../components/shared/sectionTitle.vue';
import SingleMainContainer from '../components/shared/singleMainContainer.vue';
import createListsMutation from '../mutations/createAutomatedLists';
import automatedSuggestionsListCreationTasksQuery from '../queries/getAutomatedSuggestionsListCreationTasks';
import LoginInformation from '../types/login_information';
import { ViewerContext } from '../types/viewer_context';
import * as lodash from 'lodash';

const ADMIN_LAST_SELECTION_KEY = 'adminLastSelection';

@Component({
  components: {
    SingleMainContainer,
    SectionTitle,
  },
})
export default class Admin extends Vue {
  @Getter public loginInformation!: LoginInformation;
  @Getter public viewerContext?: ViewerContext;

  public lastSavedLibraries = window.localStorage.getItem(
    ADMIN_LAST_SELECTION_KEY
  )
    ? JSON.parse(window.localStorage.getItem(ADMIN_LAST_SELECTION_KEY)!)
    : [];

  public tasksQuery = automatedSuggestionsListCreationTasksQuery;
  public name = `recommandation.ca - Recommandations pour ${this.getCurrentMonthInFrench()}, ${this.getCurrentYear()}.`;

  public allLibraries = false;

  public createCart = true;

  public bookshop = '94';
  public libraries = ['pret-test-liq'];

  public includeHighDemand = false;
  public highDemandDescription =
    'Les livres les plus en demande dans la bibliothèque';

  public includeMissingPopular = false;
  public missingPopularDescription =
    'Les livres les plus populaires dans les autres bibliothèques, mais absents du catalogue';

  public includeStaffPicks = false;
  public staffPicksDescription = 'Les coups de coeur des libraires';

  public includeSelection = false;
  public selectionDescription = 'Meilleures ventes';
  public selectionFeed = 'https://collectivites.leslibraires.ca/top.json';

  public includeUserPreferences = false;
  public userPreferencesDescription =
    'Les livres qui intéresseraient le plus les lecteurs';

  public viewAsBookshop = { id: '', name: '', type: '' };
  public viewAsLibrary = { id: '', name: '', type: '' };

  public setViewAsBookshop(): void {
    this.setViewer(this.viewAsBookshop);
  }

  public setViewAsLibrary(): void {
    this.setViewer(this.viewAsLibrary);
  }

  public async createList(): Promise<void> {
    //[{ type: HIGH_DEMAND, description: "hello" }]
    //    $name: String!
    //    $bookshopId: ID!
    //    $libraryIds: [String!]
    //    $sources: [AutomatedSuggestionsListSource!]!
    console.log(this.getCreationListVariables());
    await this.$apollo.mutate({
      mutation: createListsMutation,
      variables: this.getCreationListVariables(),
      refetchQueries: [{ query: this.tasksQuery }],
    });
  }

  public canSubmitListCreation(): boolean {
    const submissionVariables = this.getCreationListVariables();
    return (
      submissionVariables.sources.length > 0 &&
      (submissionVariables.libraryIds == null ||
        submissionVariables.libraryIds.length > 0) &&
      submissionVariables.name.trim() != ''
    );
  }

  public saveSelectionLocally(): void {
    window.localStorage.setItem(
      ADMIN_LAST_SELECTION_KEY,
      JSON.stringify(this.libraries)
    );
    this.lastSavedLibraries = this.libraries;
  }

  public loadLastLocallySavedSelection(): void {
    this.libraries = this.lastSavedLibraries;
  }

  public removeFromSelection(ids: string[]) {
    console.log('Asdasd');
    this.libraries = lodash.without(this.libraries, ...ids);
  }

  public addToSelection(ids: string[]) {
    this.libraries = lodash.union(this.libraries, ids);
  }

  public getCreationListVariables() {
    return {
      name: this.name,
      bookshopId: this.bookshop,
      createCart: this.createCart,
      // sending null for libraryIds will create the list for all libraries.
      libraryIds: this.allLibraries ? null : this.libraries,
      sources: [
        ...(this.includeHighDemand
          ? [{ type: 'HIGH_DEMAND', description: this.highDemandDescription }]
          : []),
        ...(this.includeMissingPopular
          ? [
              {
                type: 'MISSING_POPULAR',
                description: this.missingPopularDescription,
              },
            ]
          : []),
        ...(this.includeUserPreferences
          ? [
              {
                type: 'COLLABORATIVE_FILTERING',
                description: this.userPreferencesDescription,
              },
            ]
          : []),
        ...(this.includeSelection
          ? [
              {
                type: 'MARKET_SELECTION',
                description: this.selectionDescription,
                arg1: this.selectionFeed,
              },
            ]
          : []),
        ...(this.includeStaffPicks
          ? [{ type: 'STAFF_PICKS', description: this.staffPicksDescription }]
          : []),
      ],
    };
  }

  private resetViewerSelects(): void {
    this.viewAsLibrary = { id: '', name: '', type: '' };
    this.viewAsBookshop = { id: '', name: '', type: '' };
  }

  private setViewer(viewer: { id: string; name: string; type: string } | null) {
    this.$store.commit('setViewAs', viewer);
    this.resetViewerSelects();
  }

  private getCurrentYear(): number {
    return new Date().getFullYear();
  }

  private getCurrentMonthInFrench(): string {
    return [
      'janvier',
      'février',
      'mars',
      'avril',
      'mai',
      'juin',
      'juillet',
      'août',
      'septembre',
      'octobre',
      'novembre',
      'décembre',
    ][new Date().getMonth()];
  }
}
